
import React from 'react';
import {role_titles} from "../../onboarding-utils";
import {dobValidator, mmddyyyyValidator, ssnValidator, Text} from "../../prm/text";
import { Name } from "../../prm/name";
import { border_div_style } from "./common";
import {FlowRender} from "../../flow-render";
import { StateOptionMenu } from "../../prm/state-menu";
import {OptionMenu} from "../../prm/option-menu";

const PI_FIRST_NAME_0 = new Text(new Name("PI_FIRST_NAME_0", "First Name"));
const PI_LAST_NAME_0 = new Text(new Name("PI_LAST_NAME_0", "Last Name"));
const PI_DOB_0 = new Text(new Name("PI_DOB_0", "DOB"));
PI_DOB_0.setValidator(dobValidator);
PI_DOB_0.setBlurValidator(mmddyyyyValidator);
PI_DOB_0.hint = "MM/DD/YYYY";

const PI_SS_0 = new Text(new Name("PI_SS_0", "Social Security"));
PI_SS_0.setValidator(ssnValidator);

const PI_STREET_0 = new Text(new Name("PI_STREET_0", "Street"));
const PI_CITY_0 = new Text(new Name("PI_CITY_0", "City"));
const PI_STATE_0 = new StateOptionMenu(new Name("PI_STATE_0", "State"));
const PI_ZIP_0 = new Text(new Name("PI_ZIP_0", "Zip"));

const PI_FIRST_NAME_1 = new Text(new Name("PI_FIRST_NAME_1", "Name"));
const PI_LAST_NAME_1 = new Text(new Name("PI_LAST_NAME_1", "Name"));
const PI_DOB_1 = new Text(new Name("PI_DOB_1", "DOB"));
PI_DOB_1.setValidator(dobValidator);
PI_DOB_1.setBlurValidator(mmddyyyyValidator);
PI_DOB_1.hint = "MM/DD/YYYY";

const PI_SS_1 = new Text(new Name("PI_SS_1", "Social Security"));
PI_SS_1.setValidator(ssnValidator);

const PI_STREET_1 = new Text(new Name("PI_STREET_1", "Street"));
const PI_CITY_1 = new Text(new Name("PI_CITY_1", "City"));
const PI_STATE_1 = new StateOptionMenu(new Name("PI_STATE_1", "State"));
const PI_ZIP_1 = new Text(new Name("PI_ZIP_1", "Zip"));

const PRMS_0 = [
  PI_FIRST_NAME_0, PI_LAST_NAME_0, PI_DOB_0, PI_SS_0, PI_STREET_0, PI_CITY_0, PI_STATE_0, PI_ZIP_0,
];
const PRMS_1 = [
  PI_FIRST_NAME_1, PI_LAST_NAME_1, PI_DOB_1, PI_SS_1, PI_STREET_1, PI_CITY_1, PI_STATE_1, PI_ZIP_1,
];

const ALL_PRMS = new FlowRender(0, [
  ...PRMS_0, ...PRMS_1,
])

const renderColumn = (component, index, title) => {

  const prm_list = [PRMS_0, PRMS_1][index];
  const label_style = {
    fontWeight: "bold",
  }
  const lines = prm_list.map(prm => {
    let input;
    if (prm instanceof Text) {
      input = prm.renderInput(component, { width: "100%"});
    } else if (prm instanceof OptionMenu) {
      input = prm.renderMenu(component, { width: "100%"});
    }
    return (
      <div key={prm.name.id} style={{display: "flex", marginBottom: "0.2rem"}}>
        <div style={{flex: "2"}}>
          <span style={label_style}>{prm.name.label}:</span>
        </div>
        <div style={{flex: "2"}}>
          { input }
        </div>
      </div>
    )
  });

  const title_style = {
    fontWeight: "bold",
    fontSize: "1.2rem",
    flex: "2",
  }
  return (
    <div key={title}>
      <div style={{ margin: "2rem 0", display: "flex" }}>
        <div style={title_style}>
          { title }
        </div>
        <div style={{ fontSize: "1.5rem" }}>
            You can edit your details below
        </div>
      </div>
      { lines }
    </div>
  )
}

const is_dirty = (state, onboarding, index) => {
  const prms = [ PRMS_0, PRMS_1 ][index];
  const prefix = [ "role_0_", "role_1_" ][index];

  const _dirty = (prm, suffix) => {
    return prm.getValue(state) !== onboarding[prefix + suffix];
  }
  const _dirty_option = (prm, suffix) => {
    return prm.getValue(state).id !== onboarding[prefix + suffix];
  }

  return _dirty(prms[0], "first_name") || _dirty(prms[1], "last_name")
    || _dirty(prms[2], "dob") || _dirty(prms[3], "ss")
    || _dirty(prms[4], "street") || _dirty(prms[5], "city")
    || _dirty_option(prms[6], "state") || _dirty(prms[7], "zip");
}

const maybe_update = (component, num_roles) => {

  return new Promise(resolve => {
    const onboarding = component.getOnboardingData();
    let _is_dirty = is_dirty(component.state, onboarding, 0);
    if (num_roles > 1) {
      _is_dirty |= is_dirty(component.state, onboarding, 1);
    }

    if (!_is_dirty) {
      return component.saveParameters().then( () => {
        console.log("did NOT update");
        return resolve();
      })
    }

    const new_onboaring = {};
    for (let index=0; index < num_roles; index++) {
      const prms = [PRMS_0, PRMS_1][index];
      const prefix = [ "role_0_", "role_1_" ][index];

      const put_value = (prm, suffix) => {
        new_onboaring[prefix + suffix] = prm.getValue(component.state);
      }
      const put_value_option = (prm, suffix) => {
        new_onboaring[prefix + suffix] = prm.getValue(component.state).id;
      }

      put_value(prms[0], "first_name");
      put_value(prms[1], "last_name");
      put_value(prms[2], "dob");
      put_value(prms[3], "ss");
      put_value(prms[4], "street");
      put_value(prms[5], "city");
      put_value_option(prms[6], "state");
      put_value(prms[7], "zip");
    }

    component.props.dataToStore(
      new_onboaring, component.getOnboardingIndex(), component.props.username);
    component.props.dataToDynamo(
      new_onboaring, component.getOnboardingIndex(), () => {
        console.log("Did update");
        return resolve();
      }, false,
      component.props.username, component.props.identity_id);
  })


}

const PersonalInfo = props => {

  const component = props.component;
  const onboarding = component.getOnboardingData();
  const roles = role_titles(onboarding);
  const title_style = {
    fontWeight: "800",
    fontSize: "1.5rem",
  }

  return (
    <div style={border_div_style}>
      <div style={{display: "flex"}}>
        <div style={{ flex: "2"}}>
          <span style={title_style}>Personal Information</span>
        </div>
        <div style={{ flex: "2", marginTop: "0.5rem"}}>
        </div>
        <div style={{flex: "1"}}/>
      </div>
      { roles.map((role, index) => renderColumn(component, index, role))}
    </div>
  )

}

const copy_onboarding_data = (state, onboarding, index) => {
  const prefix = [ "role_0_", "role_1_" ][index];
  const set_value = (local_prm, suffix) => {
    local_prm.setValue(state, onboarding[prefix + suffix]);
  }

  set_value([ PI_FIRST_NAME_0, PI_FIRST_NAME_1 ][index], "first_name");
  set_value([ PI_LAST_NAME_0, PI_LAST_NAME_1 ][index], "last_name");
  set_value([ PI_DOB_0, PI_DOB_1 ][index], "dob");
  set_value([ PI_SS_0, PI_SS_1 ][index], "ss");
  set_value([ PI_STREET_0, PI_STREET_1 ][index], "street");
  set_value([ PI_CITY_0, PI_CITY_1 ][index], "city");
  set_value([ PI_STATE_0, PI_STATE_1 ][index], "state");
  set_value([ PI_ZIP_0, PI_ZIP_1 ][index], "zip");
}

const setup_personal_info_state = component => {
  const state = {};
  ALL_PRMS.init(state, {}, component);
  const roles = role_titles(component.getOnboardingData());
  for(let i=0; i < roles.length; i++) {
    copy_onboarding_data(state, component.getOnboardingData(), i);
  }
  return state;
}

export { PersonalInfo, setup_personal_info_state, maybe_update};
